const LOGIN_SCRIPT_ID = "login-bundle-script";

export const createLoginBundleScript = (callback?: (debtId: string) => void) => {
    const script = document.createElement("script");
    script.id = LOGIN_SCRIPT_ID;
    script.src = "/services/login/login-bundle.js";
    script.async = true;

    document.body.appendChild(script);

    if (callback) {
        window.addEventListener("loginSuccessful", function (event) {
            // @ts-ignore
            const debtId = event.detail.debtId;
            callback(debtId);
        });
    }
};
